import styled from '@emotion/styled';

export const Wrapper = styled.div``;

type RowType = {
  bg: string | null;
};
export const Label = styled.label<RowType>`
  background-color: ${(props) => props.bg ?? '#fff'};
  padding: 10px 10px 10px 44px;
  margin-bottom: 8px;
  position: relative;
  display: block;
  cursor: pointer;

  input[type='radio'] {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
    &:hover {
      cursor: pointer;
    }
  }

  .check-mark {
    top: 10px;
    left: 10px;
    position: absolute;
    height: 24px;
    width: 24px;
    border-radius: 16px;
    background-color: #fff;
    border: 1px solid #b3b8cc;
    box-shadow: 0.5px 0.5px 3px 0.6px rgba(220, 227, 235, 0.56);

    &:after {
      content: '';
      width: 12px;
      height: 12px;
      position: absolute;
      top: calc(50% - 6px);
      left: calc(50% - 6px);
      background-color: var(--lp-colors-medium-blue-600);
      border-radius: 50%;
      display: none;
    }
  }

  input:checked ~ .check-mark {
    &:after {
      display: block;
    }
  }
`;

export const TextRow = styled.div`
  display: flex;
`;

export const Text = styled.div`
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.15px;
  color: #555c7c;
`;

export const Amount = styled.div`
  font-family: 'Geograph Bold';
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.25px;
  color: #555c7c;
  font-weight: 700;
  margin-left: auto;
`;
